import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class DynamicHeaderService {
  apiUrl: string = environment.API_SERVER;
  constructor(private _http: HttpClient) { }

  getHeaderConfig(payload){
    return this._http.get(`${this.apiUrl}/api/v1/header-config/`, {
      params: payload.params,
    });
  }

  editHeaderConfig(payload){
    return this._http.put(`${this.apiUrl}/api/v1/header-config/${payload.headerConfigId}`, 
      payload.body
    );
  }

  addHeaderConfig(payload){
    return this._http.post(`${this.apiUrl}/api/v1/header-config/`, 
      payload.body
    );
  }
  deleteHeaderConfig(payload){
    return this._http.delete(`${this.apiUrl}/api/v1/header-config/${payload.headerConfigId}`,    
    );
  }

}
